import { Entity } from "./Entity";
import { DVIRTemplateType } from "./DVIRTemplate";

export type DVIRReportStatus = "created" | "completed";

export interface QuestionAnswer {
  questionId: string;
  question: string;
  isRequired: boolean;
  answer: string;
}

export interface DVIRReport extends Entity {
  templateId: string;
  vehicleId: string;
  driverId: string;
  date: string;
  questionAnswers: QuestionAnswer[];
  status: DVIRReportStatus;
  submittedAt?: string;
  // Denormalized fields for display
  templateName: string;
  templateType: DVIRTemplateType;
  driverName: string;
  vehicleLabel: string;
}

export const dvirReportStatusToText: Record<DVIRReportStatus, string> = {
  created: "Pending",
  completed: "Completed",
};
